export default "__VITE_ASSET__DnsmbSoC__"